import { render, staticRenderFns } from "./AnnouncementBanner.vue?vue&type=template&id=bf8a78f6&scoped=true"
import script from "./AnnouncementBanner.vue?vue&type=script&lang=js"
export * from "./AnnouncementBanner.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementBanner.vue?vue&type=style&index=0&id=bf8a78f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8a78f6",
  null
  
)

export default component.exports